import { put } from "redux-saga/effects";
import history from "../../history";
import { getByPath, getNavigatorInfo } from "../../helpers/utils";
import * as actions from "../actions";

export function* handle404Error() {
  yield put(actions.setLoadingState(false));
  yield put(actions.userSetIsLoading(false));
  yield history.push("/404");
}

export function* handle500Error(action) {
  const status = yield getByPath("error.request.status", action);

  const additionalInfo = yield getNavigatorInfo();

  yield window.appInsights.trackException({
    exception: new Error("500"),
    properties: {
      info: "Internal Server Error",
      status,
      ...additionalInfo,
    },
  });

  yield put(actions.setLoadingState(false));
  yield put(actions.userSetIsLoading(false));
  yield history.push("/500");
}

export function* handleOtherError(action) {
  const error = yield getByPath("error.message", action) ||
    "An internal error has occured";

  const status = yield getByPath("error.request.status", action);

  const additionalInfo = yield getNavigatorInfo();

  yield window.appInsights.trackException({
    exception: new Error(error),
    properties: {
      info: "Error has fallen outside of the expected range",
      status,
      ...additionalInfo,
    },
  });

  yield window.appInsights.flush();

  yield put(actions.setLoadingState(false));
  yield put(actions.userSetIsLoading(false));
}
